'use strict';

import { FilterType } from '../constants';


export const   setReady = state => { state.isReady = true  };
export const unsetReady = state => { state.isReady = false };

//=================================================================================================================

export const filter = (state, { type, value }) => {
	if (!FilterType[type]) { type = FilterType.all }

	switch(type) {
		case FilterType.all:
		case FilterType.popular:
			value = null;
			break;
		
		case FilterType.search:
		case FilterType.category:
			value = String(value);
			break;

		case FilterType.risk:
		case FilterType.tone:
			value = +value;
			if (!value || isNaN(value)) { value = 0 }
			break;
	}

	state.filter = { type, value };
};

//=================================================================================================================

export const showEditDialog = state => { state.editDialog.visible = true  };

//=================================================================================================================

export const hideEditDialog = state => { state.editDialog.visible = false };

//=================================================================================================================

export const setEditCopy = (state, copy) => { state.editDialog.copy = copy };

//=================================================================================================================

export const clearEditCopy = state => { state.editDialog.copy = {} };
